import type { ReactNode } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';

/** Loading and error states for one query, then `children(data)`. */
export function QueryState<T>({ query, children }: { query: UseQueryResult<T>; children: (data: T) => ReactNode }) {
  if (query.isError) {
    return (
      <p className="error-text" role="alert">
        {query.error instanceof Error ? query.error.message : 'Could not load.'}
      </p>
    );
  }
  if (query.isPending) return <p className="muted">Loading…</p>;
  return <>{children(query.data)}</>;
}
